/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomErrorResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { FlowChartResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { Measurement } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { OwnershipInfo } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { PageLikeMeasurement } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { PairLongMeasurement } from '../n3-backend-open-api-gen/model';
/**
 * MeasurementApi - axios parameter creator
 */
export const MeasurementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        device: async (deviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('device', 'deviceId', deviceId)
            const localVarPath = `/api/v1/measurement/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} deviceIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceTotalFlows: async (deviceIds: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceIds' is not null or undefined
            assertParamExists('deviceTotalFlows', 'deviceIds', deviceIds)
            const localVarPath = `/api/v1/measurement/device/total-flows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceIds) {
                localVarQueryParameter['deviceIds'] = deviceIds;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns pre-grouped interval and total-flow series for the customer device detail graph. The backend derives the local day, Monday-start week, or calendar month from viewTime and timezone.
         * @summary Get chart-ready flow data
         * @param {number} deviceId 
         * @param {FlowChartViewModeEnum} viewMode 
         * @param {string} viewTime 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowChart: async (deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('flowChart', 'deviceId', deviceId)
            // verify required parameter 'viewMode' is not null or undefined
            assertParamExists('flowChart', 'viewMode', viewMode)
            // verify required parameter 'viewTime' is not null or undefined
            assertParamExists('flowChart', 'viewTime', viewTime)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('flowChart', 'timezone', timezone)
            const localVarPath = `/api/v1/measurement/measurements/flow-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (viewMode !== undefined) {
                localVarQueryParameter['viewMode'] = viewMode;
            }

            if (viewTime !== undefined) {
                localVarQueryParameter['viewTime'] = (viewTime as any instanceof Date) ?
                    (viewTime as any).toISOString() :
                    viewTime;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a sequence of consumption values over time. Used for rendering usage charts (hourly/daily/monthly).
         * @summary Get interval flow data (history)
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intervalFlowData: async (deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('intervalFlowData', 'deviceId', deviceId)
            const localVarPath = `/api/v1/measurement/measurements/interval-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the most recent cumulative flow reading for a specific device. This represents the absolute total water that has passed through the meter.
         * @summary Get total cumulative flow for a device
         * @param {number} deviceId Internal system ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlow: async (deviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('totalFlow', 'deviceId', deviceId)
            const localVarPath = `/api/v1/measurement/total-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a sequence of absolute cumulative readings over a period. Useful for auditing meter index changes over time.
         * @summary Get total flow history
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlowData: async (deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('totalFlowData', 'deviceId', deviceId)
            const localVarPath = `/api/v1/measurement/measurements/total-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementApi - functional programming interface
 */
export const MeasurementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async device(deviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnershipInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.device(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.device']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} deviceIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceTotalFlows(deviceIds: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PairLongMeasurement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceTotalFlows(deviceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.deviceTotalFlows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns pre-grouped interval and total-flow series for the customer device detail graph. The backend derives the local day, Monday-start week, or calendar month from viewTime and timezone.
         * @summary Get chart-ready flow data
         * @param {number} deviceId 
         * @param {FlowChartViewModeEnum} viewMode 
         * @param {string} viewTime 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowChart(deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowChartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowChart(deviceId, viewMode, viewTime, timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.flowChart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a sequence of consumption values over time. Used for rendering usage charts (hourly/daily/monthly).
         * @summary Get interval flow data (history)
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async intervalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLikeMeasurement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.intervalFlowData(deviceId, from, to, pageSize, currentPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.intervalFlowData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the most recent cumulative flow reading for a specific device. This represents the absolute total water that has passed through the meter.
         * @summary Get total cumulative flow for a device
         * @param {number} deviceId Internal system ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalFlow(deviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Measurement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totalFlow(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.totalFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a sequence of absolute cumulative readings over a period. Useful for auditing meter index changes over time.
         * @summary Get total flow history
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async totalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLikeMeasurement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.totalFlowData(deviceId, from, to, pageSize, currentPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementApi.totalFlowData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementApi - factory interface
 */
export const MeasurementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementApiFp(configuration)
    return {
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        device(deviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<OwnershipInfo> {
            return localVarFp.device(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} deviceIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceTotalFlows(deviceIds: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<PairLongMeasurement>> {
            return localVarFp.deviceTotalFlows(deviceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns pre-grouped interval and total-flow series for the customer device detail graph. The backend derives the local day, Monday-start week, or calendar month from viewTime and timezone.
         * @summary Get chart-ready flow data
         * @param {number} deviceId 
         * @param {FlowChartViewModeEnum} viewMode 
         * @param {string} viewTime 
         * @param {string} timezone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowChart(deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options?: RawAxiosRequestConfig): AxiosPromise<FlowChartResponse> {
            return localVarFp.flowChart(deviceId, viewMode, viewTime, timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a sequence of consumption values over time. Used for rendering usage charts (hourly/daily/monthly).
         * @summary Get interval flow data (history)
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intervalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageLikeMeasurement> {
            return localVarFp.intervalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the most recent cumulative flow reading for a specific device. This represents the absolute total water that has passed through the meter.
         * @summary Get total cumulative flow for a device
         * @param {number} deviceId Internal system ID of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlow(deviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Measurement> {
            return localVarFp.totalFlow(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a sequence of absolute cumulative readings over a period. Useful for auditing meter index changes over time.
         * @summary Get total flow history
         * @param {number} deviceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [pageSize] 
         * @param {number} [currentPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageLikeMeasurement> {
            return localVarFp.totalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementApi - object-oriented interface
 */
export class MeasurementApi extends BaseAPI {
    /**
     * 
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public device(deviceId: number, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).device(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} deviceIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deviceTotalFlows(deviceIds: Array<number>, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).deviceTotalFlows(deviceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns pre-grouped interval and total-flow series for the customer device detail graph. The backend derives the local day, Monday-start week, or calendar month from viewTime and timezone.
     * @summary Get chart-ready flow data
     * @param {number} deviceId 
     * @param {FlowChartViewModeEnum} viewMode 
     * @param {string} viewTime 
     * @param {string} timezone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public flowChart(deviceId: number, viewMode: FlowChartViewModeEnum, viewTime: string, timezone: string, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).flowChart(deviceId, viewMode, viewTime, timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a sequence of consumption values over time. Used for rendering usage charts (hourly/daily/monthly).
     * @summary Get interval flow data (history)
     * @param {number} deviceId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [pageSize] 
     * @param {number} [currentPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public intervalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).intervalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the most recent cumulative flow reading for a specific device. This represents the absolute total water that has passed through the meter.
     * @summary Get total cumulative flow for a device
     * @param {number} deviceId Internal system ID of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public totalFlow(deviceId: number, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).totalFlow(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a sequence of absolute cumulative readings over a period. Useful for auditing meter index changes over time.
     * @summary Get total flow history
     * @param {number} deviceId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [pageSize] 
     * @param {number} [currentPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public totalFlowData(deviceId: number, from?: string, to?: string, pageSize?: number, currentPage?: number, options?: RawAxiosRequestConfig) {
        return MeasurementApiFp(this.configuration).totalFlowData(deviceId, from, to, pageSize, currentPage, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FlowChartViewModeEnum = {
    Hourly: 'hourly',
    Daily: 'daily',
    Weekly: 'weekly',
} as const;
export type FlowChartViewModeEnum = typeof FlowChartViewModeEnum[keyof typeof FlowChartViewModeEnum];
